<div
  *ngIf="isTermsAndCondition || isVerification; else imageAccessTemplate"
  class="modal-content"
  piqetAngularDraggable
>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title"
      >{{ isVerification ? '' : 'Payment Terms and Conditions' }}
    </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="container">
    <iframe class="responsive-iframe" src="" [src]="pdfFileUrl"></iframe>
  </div>
</div>

<ng-template #imageAccessTemplate>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title"> </span>
    <button
      type="button"
      class="closeModal pull-right"
      aria-label="Close"
      (click)="onSave('denied')"
      (click)="onClose()"
    >
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal pb-5">
    <h4>May PIQET use your organization's logo in marketing materials?</h4>
  </div>

  <div class="pb-4">
    <p>
      Authorized logos may be used in marketing materials like brochures or on our website. All
      information within PIQET projects is strictly confidential and will never be disclosed to the
      public. See more information about our privacy policy here -
      <a (click)="openTermsAndConditions()">Terms and conditions</a>
    </p>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancelBtn" (click)="onSave('denied')">
      No, I do not give permission.
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave('granted')">
      Yes, I give permission.
    </button>
  </div>
</ng-template>
